export const createClassName = (...args: Array<string | Record<string, boolean>>): string => {
  const classNames: string[] = [];
  args.forEach((arg) => {
    if (typeof arg === 'string') {
      classNames.push(arg);
    } else {
      Object.keys(arg).forEach((key) => {
        if (arg[key]) {
          classNames.push(key);
        }
      });
    }
  });

  return classNames.join(' ');
};
